import { gql } from '@apollo/client';
import { ITEM_FIELDS } from './items';
import { PALLET_ITEM_FIELDS } from './pallet_items';
import { EXCEPTION_FIELDS } from './db_exceptions';
import { WAREHOUSE_EVENT_FIELDS } from './order_wh_events';

// itemsByOrderId removed from here for performance reasons. Gets stitched back in later when normalizing the manifest details.
export const INBOUND_ITEM_WAREHOUSE_FIELDS = gql`
    ${PALLET_ITEM_FIELDS}
    ${EXCEPTION_FIELDS}
    ${WAREHOUSE_EVENT_FIELDS}
    fragment InboundItemWarehouseFields on manifests_inbound_items {
        mapping_id
        manifest_id
        item_id
        item {
            item_id
            order_id
            sku
            intangible
            is_return
            description
            item_type_details
            quantity
            length
            width
            height
            weight
            barcode
            serial_number
            line_id
            total_cubes
            pallet_id
            pallet {
                ...PalletItemFields
            }
            inventory_unit {
                received_at
                closed_at
            }
            latest_event: tracking_events(order_by: [{ event_time: desc_nulls_last }, { event_id: desc }], limit: 1) {
                event_id
                event_type
            }
            exceptions {
                created_at
                exception_type
                event_id
                exception {
                    ...ExceptionFields
                }
            }
            item_exception @client {
                ...ExceptionFields
            }
            order {
                order_id
                order_number
                po_number
                reference_id
                manufacturer
                dropoff_name
                dropoff_address
                dropoff_city
                dropoff_state
                dropoff_zip
                order_type
                order_status
                forward_stocked_status
                event_state
                shipper_id
                order_shipper {
                    client_id
                    business_name
                }
                wh_events(
                    order_by: [{ created_at: asc_nulls_first }, { transition: { current: asc } }, { event_id: asc }]
                ) {
                    ...WarehouseEvents
                    transition {
                        next
                        current
                    }
                }
            }
        }
    }
`;

// Minimal projection for fast manifest list queries. Pair with manifest_summary_view —
// quantity and pallet.warehouse_status are intentionally omitted, so received/staged
// counts must come from the view, not from enrichManifest's item iteration.
export const INBOUND_ITEM_SUMMARY_FIELDS = gql`
    fragment InboundItemSummaryFields on manifests_inbound_items {
        mapping_id
        manifest_id
        item_id
        item {
            item_id
            order_id
            total_cubes
            order {
                order_id
                shipper_id
                order_shipper {
                    client_id
                    business_name
                }
            }
        }
    }
`;

export const INBOUND_ITEM_FIELDS = gql`
    ${ITEM_FIELDS}
    ${WAREHOUSE_EVENT_FIELDS}
    fragment InboundItemFields on manifests_inbound_items {
        mapping_id
        manifest_id
        item_id
        item {
            ...ItemFields
            order {
                carrier_id
                event_state
                order_type
                order_id
                order_number
                order_status
                po_number
                reference_id
                dropoff_name
                dropoff_address
                manufacturer
                dropoff_location_type
                pickup_location_type
                shipper_id
                wh_events(
                    order_by: [{ created_at: asc_nulls_first }, { transition: { current: asc } }, { event_id: asc }]
                ) {
                    ...WarehouseEvents

                    transition {
                        next
                        current
                    }
                }
                itemsByOrderId {
                    ...ItemFields
                }
                order_shipper {
                    client_id
                    business_name
                }
                order_carrier {
                    client_id
                    business_name
                }
                warehouse_carrier {
                    client_id
                    business_name
                }
            }
        }
    }
`;
